/* eslint-disable no-underscore-dangle, global-require */
import React from 'react';
import { render as ReactDOMRender } from 'react-dom';

import ChannelFollowers from './ChannelFollowers';

// Element on which component will be mounted
const MOUNT_ELEMENT = document.getElementById('channel-follow');

// Allow passing context from template
const context = window.__VUMEDI_REACT_CONTEXT__;

const render = () => ReactDOMRender(<ChannelFollowers {...context} />, MOUNT_ELEMENT);

if (MOUNT_ELEMENT) {
    render();
}
